import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqList = ({ faqs = [], id = "faq" }) => (
  <Accordion type="single" collapsible className="divide-y divide-line rounded-2xl border border-line bg-panel px-5 sm:px-7" data-testid={`${id}-list`}>
    {faqs.map((f, i) => (
      <AccordionItem key={f.q} value={`q${i}`} className="border-0">
        <AccordionTrigger className="py-5 text-left font-sans text-base font-semibold text-white hover:text-gold hover:no-underline" data-testid={`${id}-question-${i}`}>
          {f.q}
        </AccordionTrigger>
        <AccordionContent forceMount className="pb-5 text-base leading-relaxed text-gray-400 data-[state=closed]:hidden">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
